/**
 * [INPUT]: 依赖原创 /logo.svg 品牌资源与 React Router Link
 * [OUTPUT]: 对外提供 Brand 首页链接组件
 * [POS]: components 的品牌入口，旭日与打开书页表达“留到明日再读”
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { Link } from 'react-router-dom'

export function Brand() {
  return (
    <Link className="brand" to="/" aria-label="Morrow 首页">
      <img src="/logo.svg" width="32" height="32" alt="" />
      <span>Morrow</span>
    </Link>
  )
}
